<template>
  <v-dialog
    persistent
    max-width="600"
    value="visible"
  >
    <v-card>
      <validation-observer
        v-slot="observer"
      >
        <v-container
          fluid
          class="text-center d-flex flex-column justify-center align-center pa-8 pt-4"
        >
          <p class="headline font-weight-bold navy-dark--text mt-6 mb-6">
            Your quote has expired
          </p>
          <p class="title navy-medium--text mb-6">
            The insurance cover start date you selected has passed.
          </p>
          <p class="body-2 navy-medium--text mb-6">
            To view updated quotes, please choose a new start date. If you need to adjust other details of your policy, you can edit the quote instead.
          </p>
          <div class="modal-content mx-6">
            <date-picker-menu
              v-model="dateOfInsurance"
              step-id="requote-expired-modal"
              field-tracker-id="requote-expired-modal_date-of-insurance-start"
              error-message="Please select a new start date."
              placeholder="Please select a new start date."
              :nudge-right="$vuetify.breakpoint.xs ? 0 : 40"
            />
          </div>
          <v-card-actions
            class="mt-2"
            :class="$vuetify.breakpoint.mdAndDown ? 'flex-column' : undefined"
          >
            <v-btn
              x-large
              rounded
              class="pl-4 pr-4 mt-4"
              @click="$emit('go-to-form')"
            >
              <v-icon
                dark
                right
                size="22"
              >
                mdi-arrow-left
              </v-icon>
              <span>Edit quote details</span>
            </v-btn>
            <v-btn
              x-large
              color="success"
              class="pl-8 pr-8 mt-4"
              :class="$vuetify.breakpoint.mdAndDown ? 'order-first ml-0' : 'order-last'"
              rounded
              @click="handleRequote(observer)"
            >
              <span>Get new quotes</span>
              <v-icon
                dark
                right
                size="22"
              >
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-container>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  ref,
} from '@vue/composition-api';
import DatePickerMenu from '@/components/DatePickerMenu.vue';

export default {
  name: 'modal-requote-expired',
  components: {
    DatePickerMenu,
  },
  setup (props, { emit }) {
    // DATA
    const dateOfInsurance = ref('');

    // METHODS
    const handleRequote = async (observer) => {
      const isValid = await observer.validate();
      if (isValid) emit('new-start-date-requote', dateOfInsurance.value);
    };

    return {
      // DATA
      dateOfInsurance,

      // METHODS
      handleRequote,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  width: 100%;
}
</style>
